import { ErrorMessage, Field } from 'formik';
import { Form, FormControl } from 'react-bootstrap';
import { FormStepHeader, RequiredIndicator } from '../../../components/forms';
import { StepProps } from '../AddChild';

export const WaiverForm = ({ touched, errors }: StepProps) => {
  return (
    <>
      <FormStepHeader title="Waiver" className="mb-3" />
      {/* TODO: Update this with waiver not from old site! */}
      {/* <object
        data="https://sfc-public.s3.us-west-2.amazonaws.com/StickyFingersCooking%C2%AE.Updated.Waiver.Generic_updated_April_2024.pdf"
        style={{ height: "60vh", width: "100%" }}
        aria-label="Waiver form PDF"
      ></object> */}
      <embed
        src="https://sfc-public.s3.us-west-2.amazonaws.com/StickyFingersCooking%C2%AE.Updated.Waiver.Generic_updated_April_2024.pdf"
        style={{ height: '60vh', width: '100%' }}
        type="application/pdf"
        aria-label="Waiver form PDF"
      />
      <Form.Group controlId="agree_to_terms">
        <Form.Label>
          <Field
            name="agree_to_terms"
            type="checkbox"
            as={Form.Check}
            label={
              <>
                Accept Terms & Conditions
                <RequiredIndicator />
              </>
            }
            isInvalid={touched.agree_to_terms && !!errors.agree_to_terms}
            aria-required
          />
        </Form.Label>
        <ErrorMessage name="agree_to_terms">
          {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
        </ErrorMessage>
      </Form.Group>
    </>
  );
};
